import { useAppSelector } from 'store/hooks';
import { selectRole } from 'store/auth/authSlice';

export type Rights = {
  upload: boolean;
  edit: boolean;
  delete: boolean;
  ownEdit: boolean;
  ownDelete: boolean;
};

export const useRights = () => {
  const role = useAppSelector(selectRole);

  return {
    edit: role === 'admin',
    delete: role === 'admin',
    toAdmin: role === 'admin',
    ownEdit: role === 'admin' || role === 'editor',
    ownDelete: role === 'admin' || role === 'editor',
    upload: role === 'admin' || role === 'editor',
    toUpload: role === 'admin' || role === 'editor',
  };
};
